import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    onUpdateColumn,
    setOrder,
    setSelectedRow
} from '../../../store/movilidad/carteravendedor/actions'; //'../../../store/channelmap/reporteseguimiento/actions';
import {sort_by} from '../../../helpers/commons'

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';


const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const CarteraVendedorList = () => {
    const classes = useStyles();
    const columns = useSelector(state => state.carteravendedor.table.columns);
    const loading = useSelector(state => state.carteravendedor.store.loading);
    const order = useSelector(state => state.carteravendedor.table.order);
    const orderBy = useSelector(state => state.carteravendedor.table.orderBy);
    const store = useSelector(state => state.carteravendedor.store);
    const dispatch = useDispatch();

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
        //dispatch(onRutasList());
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    };

    return (
        <>
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={items => dispatch(setSelectedRow(items))}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={index => store.data[index]}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>

          </>      
    )
};

export default CarteraVendedorList;